import { z } from 'zod';
export const userPolicies = z.object({
    disablePasswordlessLogin: z.boolean().optional(),
});
